import * as yup from 'yup';
import { dateValidation } from '../../AutoAccountWorkflow.validation';
import { BIRTH_DATE } from '../Steps/YourDateOfBirth/YourDateOfBirth';
import { TOTAL_INVESTABLE_ASSETS } from '../Steps/TotalValueInvestableAssets/TotalValueInvestableAssets';
import { HOW_MUCH_SAVED } from '../Steps/HowMuchSavePerMonth/HowMuchSavePerMonth';
import { SIMPLE_IRA_PLAN_NAME } from '../Steps/SimpleIraPlanName/SimpleIraPlanName';
import { AccountTypeOptionsDTO } from '../../api/useAutomatedAccountsQuery';

export const retirementValidation = yup.object().shape({
  [SIMPLE_IRA_PLAN_NAME]: yup
    .string()
    .nullable()
    .when('accountType', {
      is: AccountTypeOptionsDTO.SimpleIRA,
      then: yup.string().required('Please enter a plan name'),
    }),
  [BIRTH_DATE]: yup.string().test('birthDate', 'Please enter a valid birth date', dateValidation),
  [TOTAL_INVESTABLE_ASSETS]: yup
    .string()
    .nullable()
    .required('Please enter an amount'),
  [HOW_MUCH_SAVED]: yup
    .string()
    .nullable()
    .required('Please enter an amount'),
});
